<template>
  <div class="h-100">
    <main role="main">
      <common-master-table
        primary-key="logSerialId"
        tableNo="trLog"
        table-api="log/get"
        ref="commonMasterTable"
        :mapping-no="`ie-log`"
        :displayDialogViewDetail="true"
        :hideSaveToAction="true"
        :hideDeleteToAction="true"
        :hideChbxColumn="true"
        :hideChbxAllColumn="true"
        :hideFirstColHeader="true"
        :hideButtonImportCsv="true"
        :hideButtonAdd="true"
        :hideEditButton="true"
        :hideDeleteButton="true"
        :hideButtonDeleteAll="true"
        :showLockMasterButton="false"
        class="logMasterTable"
        socket-entity="LOG_SOCKET"
      />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from './custom-components/CommonMasterTable'
import RouterUtils from '../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      isRemoveCheck: true,
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
main {
  height: 100%;
}

.logMasterTable >>> .table_wrapper {
  max-height: 100% !important;
  min-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LogInformation.vue